import { render } from "./BerichteVerwaltungDetails.pug?vue&type=template&id=58492988&lang=pug"
import script from "./BerichteVerwaltungDetails.js?vue&type=script&lang=js"
export * from "./BerichteVerwaltungDetails.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__